// M4-A6 — File/PDF/Download/Share nativi per Capacitor. Additivo: sul web tutto no-op.
// PDF/allegati privati restano AUTH-GATED: fetch autenticato (Bearer via interceptor api.js)
// → file temporaneo nella cache dell'app → share/viewer nativo. Nessun token in URL/filename.
import { toast } from "sonner";
import { isNative } from "./mobileAuth";
import { api, MOBILE_WEB_ORIGIN } from "./api";

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onloadend = () => resolve(String(r.result).split(",")[1] || "");
    r.onerror = reject;
    r.readAsDataURL(blob);
  });
}

function safeFilename(name) {
  const base = (name || "documento").split("/").pop().split("\\").pop();
  return base.replace(/[^A-Za-z0-9._-]/g, "_").slice(0, 120) || "documento";
}

// Scarica in modo autenticato un file privato e lo apre/condivide col sistema.
// apiPath: percorso completo che inizia con "/api/..." (lo stesso passato a fileHref).
export async function openAuthedFile(apiPath, filename) {
  if (!isNative()) return; // web: gestito dall'<a href> esistente
  try {
    const rel = String(apiPath).replace(/^\/api/, ""); // api baseURL contiene già /api
    const resp = await api.get(rel, { responseType: "blob" }); // Bearer allegato dall'interceptor
    const b64 = await blobToBase64(resp.data);
    const name = safeFilename(filename);
    const { Filesystem, Directory } = await import("@capacitor/filesystem");
    await Filesystem.writeFile({ path: name, data: b64, directory: Directory.Cache });
    const { uri } = await Filesystem.getUri({ path: name, directory: Directory.Cache });
    const { Share } = await import("@capacitor/share");
    await Share.share({ title: filename || "Documento", url: uri });
  } catch (e) {
    toast.error("Impossibile aprire il file. Riprova.");
  }
}

// onClick per gli <a> di download: sul web lascia il comportamento nativo del link,
// su Capacitor intercetta e usa il flusso autenticato → cache → share.
export function onAuthedFileClick(e, apiPath, filename) {
  if (!isNative()) return;
  e.preventDefault();
  openAuthedFile(apiPath, filename);
}

// Condivisione di LINK PUBBLICI (senza token). Web: navigator.share/clipboard (invariato).
// Capacitor: plugin Share nativo. Se url è relativo, usa il dominio web canonico (mai capacitor://).
export async function shareLink({ title, text, url }) {
  let finalUrl = url;
  if (isNative() && url && url.startsWith("/")) finalUrl = `${MOBILE_WEB_ORIGIN}${url}`;
  if (isNative()) {
    try {
      const { Share } = await import("@capacitor/share");
      await Share.share({ title, text, url: finalUrl });
      return "shared";
    } catch (e) {
      return "cancelled";
    }
  }
  // Web invariato
  if (navigator.share) {
    try { await navigator.share({ title, text, url: finalUrl }); return "shared"; }
    catch (e) { return "cancelled"; }
  }
  try { await navigator.clipboard.writeText(finalUrl || text || ""); return "copied"; }
  catch (e) { return "error"; }
}
